// client/src/api/clientes.js
import api from "./config.js";

// Obtener todos los clientes
export const getClientes = async () => {
    const { data } = await api.get("/clientes");
    return Array.isArray(data) ? data : data.clientes || [];
};

// Obtener cliente por ID
export const getCliente = async (id) => {
    const { data } = await api.get(`/clientes/${id}`);
    return data;
};

// Crear cliente
export const createCliente = async (cliente) => {
    const { data } = await api.post("/clientes", cliente);
    return data;
};

// Actualizar cliente
export const updateCliente = async (id, cliente) => {
    const { data } = await api.put(`/clientes/${id}`, cliente);
    return data;
};

// Eliminar cliente
export const deleteCliente = async (id) => {
    const { data } = await api.delete(`/clientes/${id}`);
    return data;
};
